import { httpClient } from "../funcs";

export type ImportRealtyObjectsResult = {
    objects_count: number;
    message?: string;
};

/**
 * Импорт объектов из RealtyCalendar в шаблон договора.
 * Бросает исключение при ошибке (нет ключа, сеть, 4xx/5xx).
 */
export async function importRealtyObjects(
    templateId: string,
    realtyApiKey: string
): Promise<ImportRealtyObjectsResult> {
    const response = await httpClient.post<ImportRealtyObjectsResult>(
        "/template/import-realty-objects",
        {
            template_id: templateId,
            realty_api_key: realtyApiKey,
        }
    );
    return response.data;
}
